import React from 'react';
import PropTypes from 'prop-types';
import Avatar from '../../../../components/avatar';
import styles from './styles.css';

function NameCellRenderer(props) {
  const { value } = props;
  return (
    <div>
      <Avatar className={styles.avatar} size={22} user={value} /> {value.name}
    </div>
  );
}

NameCellRenderer.propTypes = {
  value: PropTypes.shape({}).isRequired,
};

export default NameCellRenderer;
